import { useEffect, useState } from "react";
import BodyHeader from "../../../../components/common/CommonBodyHeader";
import CustomInput from "../../../../components/common/CustomInput/CustomInput";
import CustomTable from "../../../../components/common/CustomTable";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { backdropLoadingAction } from "../../../../redux/features/helperSlice";
import { BsPencilSquare } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

import { tonnageListAsync } from "../../../../redux/features/tonnage-master/tonnageSlice";
import CustomToggleSwitch from "../../../../components/common/CustomToggle";

import { categoryListAsync } from "../../../../redux/features/vehicle-category/categoriesSlice";
import { changeStatus } from "../../../../Api/dispatch/vehicle-category-dispatch";

export default function VehicleCategoryList(){
   const dispatch = useDispatch();
   const navigate = useNavigate();
   const masterList = useSelector((state) => state.categoryMasterSlice.data);

   const [records, setRecords] = useState([]);

   const [isActiveLoading, setIsActiveLoading] = useState({
      id: "",
      status: false,
   });


      // Handle active inactive
      const handleActiveInactive = (category) => {
         setIsActiveLoading({ id: category?.id, status: true });
         changeStatus({ id: category?.id, status: category?.is_active === "1" ? "0" : "1" })
            .then((res) => {
               setIsActiveLoading({ id: category?.id, status: false });
               dispatch(categoryListAsync({}));
               toast.success(
                  `category ${category?.is_active === "1" ? "deactivated" : "activated"}`
               );
            })
            .catch((error) => {
               setIsActiveLoading({ id: category?.id, status: false });
               //toast.error(
               //    `Failed to ${
               //       category?.is_active === "1" ? "deactivate" : "activate"
               //    } location`
               // );
            });
      };

   const columns = [
        {
           name: "Categories",
           selector: (row) => row.category_name,
           sortable: true,
        },
       {
         name: "Action",
         width: "9rem",
         selector: (row) => {
            return (
               <div className="d-flex align-items-center">
                  <button
                     className="btn"
                     onClick={() => navigate(`/fleet-master/vehicle-category/edit/${row.id}`)}
                  >
                     <BsPencilSquare
                        className="text-primary"
                        style={{ height: "1.5rem", width: "1.5rem" }}
                     />
                  </button>

                  <CustomToggleSwitch
                     checked={row?.is_active === "1"}
                     onChange={() => handleActiveInactive(row)}
                     isLoading={isActiveLoading.id === row?.id && isActiveLoading.status}
                  />                 
               </div>
            );
         },
      },


    ];


    useEffect(() => {
      dispatch(backdropLoadingAction(true));
      dispatch(
         categoryListAsync({
            done: () => {
               dispatch(backdropLoadingAction(false));
            },
            err: (error) => {
               dispatch(backdropLoadingAction(false));
               //toast.error(error);
            },
         })
      );
   }, []); 


   useEffect(() => {
      if (masterList) setRecords(masterList);
   }, [masterList]);


   const handleFilter = (e) => {
      const searchText = e.target.value.toLowerCase();
      const newData = masterList?.filter((item) => {
         return (
            item?.category_name?.toLowerCase().includes(searchText)
         );
      });
      setRecords(newData);
   };

    return (
        <div>
           <BodyHeader title="Vehicle Category List" />

           <div className="px-3">
            <div className="d-flex justify-content-start">
               <CustomInput
                  inputType="text"
                  placeholder="Search..."
                  id="search"
                  onChange={(e) => handleFilter(e)}
               />
            </div>
            <CustomTable columns={columns} data={records} />
         </div>

        </div>
    );
}